import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import CheckCircle from "@material-ui/icons/CheckCircle";

import { hist } from '../../../index';

export class ModelImpl extends Component {

  render() {
    const { msg, path, show }= this.props;
    return (
      <Modal
          show= {show}
          className="common-modal"
        >
        <Modal.Body>
          <div className="common-modal-content">
            <CheckCircle/>
            <span>{msg}</span>
            <div className="common-modal-button remove_project">
              <button className="main-btn" onClick= {()=> {
                hist.push(path)
              }}>OK</button>
            </div>
          </div>          
        </Modal.Body>       
      </Modal>
    )
  }
}

export default connect(null, {
})(ModelImpl)


// WEBPACK FOOTER //
// ./src/components/Common/Model/CommonModel.jsx